module.exports = __webpack_public_path__ + "static/media/konsepti.1f604067.png";